// Converted to lazy loading
const deliveriesIndex = () => import('@/pages/shipping/deliveries/index.vue')
const deliveriesForm = () => import('@/pages/shipping/deliveries/form.vue')

const citiesIndex = () => import('@/pages/shipping/cities/index.vue')
const citiesForm = () => import('@/pages/shipping/cities/form.vue')

const pickupLocationsIndex = () => import('@/pages/shipping/pickupLocations/index.vue')
const pickupLocationsForm = () => import('@/pages/shipping/pickupLocations/form.vue')

const shippingOperationsIndex = () => import('@/pages/shipping/shippingOperations/index.vue')
const shippingOperationsForm = () => import('@/pages/shipping/shippingOperations/form.vue')
const shippingOperationsShow = () => import('@/pages/shipping/shippingOperations/show.vue')

const shippingAddressesIndex = () => import('@/pages/shipping/shippingAddresses/index.vue')
const shippingAddressesForm = () => import('@/pages/shipping/shippingAddresses/form.vue')

const routes = [
  //deliveries routes
  {
    path: 'deliveries',
    name: 'deliveries',
    component: deliveriesIndex
  },
  {
    path: 'deliveries/create',
    name: 'deliveriesCreate',
    component: deliveriesForm
  },
  {
    path: 'deliveries/:id/edit',
    name: 'deliveriesEdit',
    component: deliveriesForm
  },

  //cities routes
  {
    path: 'cities',
    name: 'cities',
    component: citiesIndex
  },
  {
    path: 'cities/create',
    name: 'citiesCreate',
    component: citiesForm
  },
  {
    path: 'cities/:id/edit',
    name: 'citiesEdit',
    component: citiesForm
  },

  //pickupLocations routes
  {
    path: 'pickupLocations',
    name: 'pickupLocations',
    component: pickupLocationsIndex
  },
  {
    path: 'pickupLocations/create',
    name: 'pickupLocationsCreate',
    component: pickupLocationsForm
  },
  {
    path: 'pickupLocations/:id/edit',
    name: 'pickupLocationsEdit',
    component: pickupLocationsForm
  },

  //shippingOperations routes
  {
    path: 'shippingOperations',
    name: 'shippingOperations',
    component: shippingOperationsIndex
  },
  {
    path: 'shippingOperations/create',
    name: 'shippingOperationsCreate',
    component: shippingOperationsForm
  },
  {
    path: 'shippingOperations/:id/edit',
    name: 'shippingOperationsEdit',
    component: shippingOperationsForm
  },
  {
    path: 'shippingOperations/:id',
    name: 'shippingOperationsShow',
    component: shippingOperationsShow
  },
  //shippingAddresses
  {
    path: 'shippingAddresses',
    name: 'shippingAddresses',
    component: shippingAddressesIndex
  },
  {
    path: 'shippingAddresses/create',
    name: 'shippingAddressesCreate',
    component: shippingAddressesForm
  },
  {
    path: 'shippingAddresses/:id/edit',
    name: 'shippingAddressesEdit',
    component: shippingAddressesForm
  }
]

export default routes
